import type { JSX } from 'solid-js';
import { t } from '../i18n';

// Beside the org Members invite, for STAFF only (plan 102 slice 05): this invite adds
// a person to THIS account — its machines, its keys — which is the wrong door for a
// friend who should run on their own. Staff hold the right one, `/admin` Users →
// Invite by email (`<AdminInviteByEmail/>`), so the note names it. The caller gates
// on `/v1/me`'s `is_platform_admin`.

export function InviteSharesNote(): JSX.Element {
  return (
    <p class="field__desc">
      {t('org_members.invite_shares_note')}{' '}
      <a href="/admin/users">{t('org_members.invite_shares_link')}</a>
    </p>
  );
}
